import { createElement } from 'react';
import { hydrateRoot } from 'react-dom/client';
import Page from '/app/packages/app/pages/menus/feeds/bluesky.tsx';

window.__REX_PAGES = window.__REX_PAGES || {};
window.__REX_PAGES['/menus/feeds/bluesky'] = { default: Page };

// Expose render function for client-side navigation (used by router.js)
if (!window.__REX_RENDER__) {
  window.__REX_RENDER__ = function(Component, props) {
    var element;
    if (window.__REX_APP__) {
      element = createElement(window.__REX_APP__, { Component: Component, pageProps: props });
    } else {
      element = createElement(Component, props);
    }
    if (window.__REX_ROOT__) {
      window.__REX_ROOT__.render(element);
    }
  };
}

if (!window.__REX_NAVIGATING__) {
  var dataEl = document.getElementById('__REX_DATA__');
  var pageProps = dataEl ? JSON.parse(dataEl.textContent) : {};
  var container = document.getElementById('__rex');
  if (container) {
    var element;
    if (window.__REX_APP__) {
      element = createElement(window.__REX_APP__, { Component: Page, pageProps: pageProps });
    } else {
      element = createElement(Page, pageProps);
    }
    window.__REX_ROOT__ = hydrateRoot(container, element);
  }
}
